import React, { useState } from 'react';
import { formatTrustCount } from '../../../utils/publicTrust/publicTrustCopy.ts';
import styles from './PublicTrustSnapshotCard.module.scss';

type TrustOverflowBadgeProps = {
  count: number;
};

const TrustOverflowBadge: React.FC<TrustOverflowBadgeProps> = ({ count }) => {
  const [active, setActive] = useState(false);
  const formatted = formatTrustCount(count);

  return (
    <div
      className={`${styles.overflowSlot} ${styles.popoverAlignEnd} ${active ? styles.avatarSlotActive : ''}`}
      onMouseEnter={() => setActive(true)}
      onMouseLeave={() => setActive(false)}
      onFocus={() => setActive(true)}
      onBlur={(event) => {
        if (!event.currentTarget.contains(event.relatedTarget as Node | null)) {
          setActive(false);
        }
      }}
      tabIndex={0}
      role="button"
      aria-label={`${formatted} profesionales más en la red`}
    >
      <span className={styles.overflowBadge}>+{formatted}</span>
      <div className={styles.avatarPopover} role="tooltip">
        <p className={styles.popoverOverflowTitle}>+{formatted} profesionales más</p>
        <p className={styles.popoverOverflowText}>
          Otros perfiles en Edify también pueden ver tu publicación y enviarte presupuestos.
        </p>
      </div>
    </div>
  );
};

export default TrustOverflowBadge;
